export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const CLEAR_USER_LOGGED = 'CLEAR_USER_LOGGED'
export const CHANGE_USER_INFO = 'CHANGE_USER_INFO'

export const GLOBAL_SEARCH = 'GLOBAL_SEARCH'
export const TAG_SEARCH = 'TAG_SEARCH'

export const GET_USERINFO = 'GET_USERINFO'
export const UPDATE_USERINFO = 'UPDATE_USERINFO'
export const BIND_WECHAT = 'BIND_WECHAT'
export const UNBIND_WECHAT = 'UNBIND_WECHAT'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'

export const GET_VIP_INFORMATION = 'GET_VIP_INFORMATION'

export const SORT_RECENT_HOT_EVENT = 'SORT_RECENT_HOT_EVENT'
export const COLLECT_RECENT_HOT_EVENT = 'COLLECT_RECENT_HOT_EVENT'
export const GET_RECENT_HOT_EVENT = 'GET_RECENT_HOT_EVENT'

export const GET_WECHAT_REGISTER_PROFILE = 'GET_WECHAT_REGISTER_PROFILE'

export const UPDATE_WECHAT_DATA = 'UPDATE_WECHAT_DATA'

export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR'

export const GET_MY_INVOICE = 'GET_MY_INVOICE'

export const SUBMIT_AN_INVOICE = 'SUBMIT_AN_INVOICE'

export const UPDATE_VIP_ROLE = '  UPDATE_VIP_ROLE,'

export const GET_INDEX_CASE_REVIEWS = 'GET_INDEX_CASE_REVIEWS'
export const GET_INDEX_CASE_NEWS = 'GET_INDEX_CASE_NEWS'
export const GET_INDEX_REPORT_NEWS = 'GET_INDEX_REPORT_NEWS'
export const GET_INDEX_COMPARE = 'GET_INDEX_COMPARE'

// crisis rank
export const GET_RANK_INFO = 'GET_RANK_INFO'
export const GET_RANK_EVENTS = 'GET_RANK_EVENTS'
export const GET_RANK_BRANDS = 'GET_RANK_BRANDS'

// compare events
export const UPDATE_COMPARE_IDS = 'UPDATE_COMPARE_IDS'

// echarts
export const EVENT_GAUGE_DATA = 'EVENT_GUAGE_DATA'
export const EVENT_LIQUID_FILL_DATA = 'EVENT_LIQUID_FILL_DATA'



// WEBPACK FOOTER //
// ./src/pages/index/store/mutiation.js